import * as React from 'react';

import { Actions } from './actions';
import { AppContextState } from './types';

export type Context = {
    state: AppContextState;
    dispatch: React.Dispatch<Actions>;
};

export const defaultState: AppContextState = {
    isLoading:false
};

export const store = React.createContext<Context>({
    state: defaultState,
    dispatch: () => null
});